import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserData {
  documentOwner: string;
  id: number;
  name: string;
  user: string;
  password: string;
  lastSyncDate: string;
}

interface LoginState {
  user: UserData | null;
  token: string | null;
  error: string;
  success: boolean;
  isUserLogout: boolean;
  isLoading: boolean;
}

const initialState: LoginState = {
  user: null,
  token: null,
  error: "",
  success: false,
  isUserLogout: false,
  isLoading: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginStart(state) {
      state.isLoading = true;
      state.error = "";
    },
    loginSuccess(state, action: PayloadAction<{ user: UserData; token: string }>) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.success = true;
      state.isLoading = false;
      state.error = "";

      localStorage.setItem("authUser", JSON.stringify(action.payload.user));
      localStorage.setItem("accessToken", action.payload.token);
    },
    loginError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.success = false;
      state.isLoading = false;
    },
    logoutSuccess(state) {
      state.user = null;
      state.token = null;
      state.isUserLogout = true;
      state.success = false;
    },
    clearError(state) {
      state.error = "";
    },
  },
});

export const { loginStart, loginSuccess, loginError, logoutSuccess, clearError } =
  loginSlice.actions;
export default loginSlice.reducer;
